module.exports = __webpack_public_path__ + "static/media/general-background@2x.1b3a7e87.jpg";